// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__lESha","disactive":"Navbar_disactive__jr5h1"};